// BUGS.md X5: the unread count drawn inside the Chats menu button joined the button's name, so a screen reader heard
// "Chats 1" with the digits run on. The digits stay drawn as before and are hidden from the reader, which hears
// "Chats, 1 unread" instead, as the messenger's own badge says (Messenger.tsx).

/** The unread count beside a menu entry: drawn as the digits, read as ", N unread". Nothing when there is none. */
export function NavUnread({ n }: { n: number }) {
  if (n <= 0) return null;
  return (
    <>
      <span className="unread" aria-hidden="true">{n > 99 ? '99+' : n}</span>
      <span className="sr-only">{`, ${n} unread`}</span>
    </>
  );
}
